// @ts-nocheck
/* eslint-disable */
export const llaPlatformArrowNorthEastIcon = {
    data: `<svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.9375 7.4375V1.0625H2.5625" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 1.25L1.0625 8.9375" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-north-east' as const
};